import { Button, Group, Stack } from '@mantine/core';

import { Select } from '@components';
import { SimulateTsdModalProps } from '@features/tsd/TSDList/CustomsSimulator/types';
import { useSimulateTsdActivationFormInitializer } from './useSimulateTsdActivationFormInitializer';

const ACTIVATION_STATUS_OPTIONS = [
  { value: '02', label: '02 - Accepted' },
  { value: '06', label: '06 - Irregularity under investigation' },
];

export const SimulateTsdActivation: React.FC<SimulateTsdModalProps> = ({ tsd, onHide, onSubmit }) => {
  const {
    form,
    onSubmit: onSubmitForm,
    submitting,
  } = useSimulateTsdActivationFormInitializer({
    tsd,
    onHide,
    onSubmit,
  });

  return (
    <form onSubmit={form.onSubmit(onSubmitForm)}>
      <Stack gap="sm" mb="xl">
        <Select {...form.getInputProps('status')} label="Status" placeholder="Select status" data={ACTIVATION_STATUS_OPTIONS} allowDeselect={false} />
      </Stack>

      <Group justify="center">
        <Button type="button" onClick={onHide} disabled={submitting} size="lg" variant="transparent">
          Cancel
        </Button>

        <Button type="submit" loading={submitting} variant="filled" size="lg" data-pw="simulate-iets029-btn">
          Trigger
        </Button>
      </Group>
    </form>
  );
};
